<div class="w-full min-h-screen bg-[#F8F9FA] flex flex-col font-sans">
  
  <div *ngIf="isLoading" class="flex-grow flex justify-center items-center">
    <div class="w-4 h-4 rounded-full animate-pulse bg-[#1D4586] mr-1"></div>
    <div class="w-4 h-4 rounded-full animate-pulse bg-[#1D4586] mr-1"></div>
    <div class="w-4 h-4 rounded-full animate-pulse bg-[#1D4586]"></div>
  </div>

  <ng-container *ngIf="!isLoading && questions.length > 0">
    <!-- Top Action Bar -->
    <div class="w-full bg-white px-8 py-4 border-b border-gray-200 flex justify-between items-center shadow-sm">
      <div class="flex items-center">
        <img src="../../../assets/icons/copilot-bot.png" class="w-8 h-8 mr-3" alt="Bot" />
        <h2 class="text-lg font-bold text-[#1D4586]">{{ assessmentTitle }}</h2>
        <button (click)="saveAndExit()" class="ml-4 px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 text-gray-700">
          Save & exit
        </button>
      </div>
      
      <!-- Persistent Submit Button -->
      <button (click)="submitAssessment()" 
              [disabled]="!canSubmit || isSubmitting"
              [ngClass]="canSubmit ? 'bg-[#1D4586] hover:bg-[#16366b] text-white' : 'bg-gray-300 text-gray-500 cursor-not-allowed'"
              class="px-6 py-2 rounded font-semibold text-sm transition-colors">
        {{ isSubmitting ? 'Submitting...' : 'Submit Assessment' }}
      </button>
    </div>

    <!-- Sub Header & Navigation -->
    <div class="w-full px-8 py-3 bg-gray-100 border-b border-gray-200 text-sm font-semibold text-gray-600 uppercase tracking-wide">
      {{ assessmentTitle }} &mdash; Q{{ currentQuestion.position }}
    </div>

    <div class="flex justify-center items-center py-6 gap-4">
      <button (click)="prevQuestion()" [disabled]="currentIndex === 0" class="text-[#1D4586] disabled:text-gray-400 hover:text-[#16366b] p-2">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
      </button>
      <span class="font-bold text-gray-800">Question {{ currentQuestion.position }} of {{ questions.length }}</span>
      <button (click)="nextQuestion()" [disabled]="currentIndex === questions.length - 1" class="text-[#1D4586] disabled:text-gray-400 hover:text-[#16366b] p-2">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
      </button>
    </div>

    <!-- Question Card Area -->
    <div class="w-full max-w-4xl mx-auto px-4 pb-12">
      <div class="bg-white border border-gray-200 rounded-lg shadow-sm p-8">
        
        <!-- Question Text -->
        <h3 class="text-[16px] font-bold text-gray-900 mb-6 leading-relaxed">
          {{ currentQuestion.question }}
        </h3>

        <!-- MCQ Layout -->
        <div *ngIf="currentQuestion.question_type === 'mcq'" class="space-y-3 mb-8">
          <label *ngFor="let opt of currentQuestion.options" 
                 class="block border rounded-md p-4 cursor-pointer transition-all"
                 [ngClass]="currentQuestion.selected_option === opt.key ? 'border-[#1D4586] bg-[#F3F7FC]' : 'border-gray-300 hover:border-gray-400'">
            <div class="flex items-center">
              <input type="radio" 
                     [name]="'q_' + currentQuestion.question_id" 
                     [value]="opt.key" 
                     [(ngModel)]="currentQuestion.selected_option"
                     class="w-4 h-4 text-[#1D4586] focus:ring-[#1D4586] border-gray-300 mr-3">
              <span class="text-gray-800 text-sm font-medium">{{ opt.text }}</span>
            </div>
          </label>
        </div>

        <!-- Descriptive Layout -->
        <div *ngIf="currentQuestion.question_type === 'descriptive'" class="mb-8">
          <textarea [(ngModel)]="currentQuestion.answer_text" 
                    rows="6" 
                    placeholder="Type your answer..."
                    class="w-full border border-gray-300 rounded-md p-4 text-gray-800 focus:ring-1 focus:ring-[#1D4586] focus:border-[#1D4586] outline-none resize-y"></textarea>
          <p *ngIf="currentQuestion.help" class="text-xs text-gray-500 mt-2 italic">{{ currentQuestion.help }}</p>
          
          <div class="flex justify-between items-center mt-3 text-xs text-gray-500 font-medium">
            <span>{{ currentQuestion.max_marks }} marks &middot; evaluated by AI</span>
            <span>{{ wordCount }} words</span>
          </div>
        </div>

        <!-- Save Button -->
        <!-- Save Button -->
        <div class="flex justify-center mt-4">
          <button (click)="saveAnswer()" 
                  [disabled]="isSaving || !canSaveCurrent"
                  [ngClass]="isSaving || !canSaveCurrent ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#1D4586] text-white hover:bg-[#16366b]'"
                  class="px-8 py-3 rounded font-semibold text-sm transition-colors flex items-center">
            <span *ngIf="isSaving" class="mr-2 h-4 w-4 rounded-full border-2 border-t-transparent border-white animate-spin"></span>
            {{ isSaving ? 'Saving...' : 'Save Answer' }}
          </button>
        </div>

      </div>
    </div>
  </ng-container>
</div>